import { useResources } from "../../hooks/useResources";
import ContentHeader from "../contentHeader/ContentHeader";
import type { JobFile } from "../../interfaces/apiInterfaces/jobs";
import ScrollbarArrows from "../table/ScrollbarArrows";
import { formatDateTime, renderFileStatus } from "../table/TableUtils";

interface JobHistoryProps {
  files: JobFile[];
  onDownloadFile: (fileId: string, fileName: string) => void;
}

const JobHistory = ({ files, onDownloadFile }: JobHistoryProps) => {
  const { getResourceValue } = useResources();

  return (
    <>
      <ContentHeader
        title={getResourceValue("history", "History")}
        headingLevel={2}
        showActions={false}
        className="content-header--section-title"
      />
      <div className="job-details__questions-section job-details__history-section">
        <ScrollbarArrows
          targetId="job-history-table-scroll"
          tablesScroll={5}
        />
        <div className="data-table-wrapper" id="job-history-table-scroll">
          <table className="data-table">
            <thead>
              <tr>
                <th>{getResourceValue("uploaded_file_name", "Uploaded File Name")}</th>
                <th>{getResourceValue("upload_date_time", "Upload Date and Time")}</th>
                <th>{getResourceValue("email", "Email")}</th>
                <th>{getResourceValue("status", "Status")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {files.map((file, index) => (
                <tr key={index}>
                  <td>{file.file_name}</td>
                  <td>{formatDateTime(file.created_at_utc)}</td>
                  <td>{file.user_email}</td>
                  <td>{renderFileStatus(file.file_status)}</td>
                  <td>
                    <div className="table-actions">
                      <button
                        className="btn btn-green"
                        onClick={() => onDownloadFile(file.file_id, file.file_name)}
                      >
                        <i className="f-icon download-icon"></i>
                        {getResourceValue("download_log", "Download Log")}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default JobHistory;

